/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CleanableNumber } from './cleanableNumber';
import { Order } from './order';
import { Long2ObjectHashMapCleanableNumber } from './long2ObjectHashMapCleanableNumber';
import { OrderStateActiveQtyByRouteOrder } from './orderStateActiveQtyByRouteOrder';
import { Pair } from './pair';

export interface OrderState {
  pair?: Pair;
  order?: Order;
  qtyInBaseAsset?: boolean;
  leavesQty?: number;
  estLockPrice?: number;
  lock?: number;
  hedgedQty?: number;
  filledQty?: number;
  lastQty?: number;
  realExecVolume?: number;
  clientExecVolume?: number;
  baseAssetFee?: number;
  baseAssetFeeConverted?: number;
  lastBaseAssetFee?: number;
  lastBaseAssetFeeConverted?: number;
  lpFilledQty?: number;
  activeQtyByRouteOrder?: OrderStateActiveQtyByRouteOrder;
  activeLpVolumeByRouteOrder?: Long2ObjectHashMapCleanableNumber;
  pendingCancel?: boolean;
  activeQty?: CleanableNumber;
}
